import React from "react";
import { Stepper, Step } from "../../../components/shared/Stepper";

interface StepperProps {
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

const steps: Step[] = [
  {
    stepNo: 1,
    title: "Grant Scope",
    description: "Scope of valuation",
  },
  {
    stepNo: 2,
    title: "Valuation Assumptions",
    description: "Key valuation inputs",
  },
  {
    stepNo: 3,
    title: "Other Assumptions",
    description: "Additional parameters",
  },
  {
    stepNo: 4,
    title: "Preview",
    description: "Review inputs",
  },
  {
    stepNo: 5,
    title: "Summary & Apply",
    description: "Finalize report",
  },
];

export const BlackScholesStepper: React.FC<StepperProps> = ({
  currentStep,
  setCurrentStep,
}) => (
  <Stepper
    steps={steps}
    currentStep={currentStep}
    onStepClick={(step) => {}}
    className="h-full min-h-[400px]"
  />
);
